import React, { Component } from 'react';
import Layout from './screens/layout';
import { withTranslation } from 'react-i18next';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      translation: this.props.t
    }
  }
  
  render() {
    return (
        <div className="App">
          <Layout {...this.state}/>
        </div>
    );
  }

}

export default withTranslation()(App)

